export const isLeftSafe = (podName = "") =>
  podName.toLowerCase() === "left safe";
